import { FC } from "react";
import trans from "helpers/trans";

const NotFound: FC = () => {
    return <p>{trans("app.page.notFound.text")}</p>;
};

export default NotFound;
